import Banner from "../components/Banner/Banner";
import ContactFormSection from "../components/ContactForm/ContactFormSection";
import Footer from "../components/Footer/Footer";
import Navigation from "../components/Navigation/Navigation";
import Spinner from "../components/Spinner/Spinner";

function ContactUs() {
  return (
    <div className="container-xxl bg-white p-0">
      <Spinner />
      <Navigation />
      <Banner pageName="Contact Us" />
      <ContactFormSection />
      <Footer />
    </div>
  );
}

export default ContactUs;
